import EditIcon from '@mui/icons-material/Edit';
import RestoreIcon from '@mui/icons-material/Restore';
import { useTranslation } from 'react-i18next';

import { ActionButtonGroupAction } from '@/components/ActionButtonGroup/ActionButtonGroup';
import { useInlineEditContext } from '@/components/EditableSectionField/InlineEditContext';
import { useBreakpoint } from '@/utils/useBreakpoint';

export const useDcrControlAction = (): ActionButtonGroupAction | null => {
	const { t } = useTranslation();
	const isCollapsed = useBreakpoint('lg', 'down');
	const ctx = useInlineEditContext();
	const isProfileInactive = ctx?.entity?.statusCda_VId === 'iact';

	if (!ctx?.canRequestChange) {
		return null;
	}

	const Icon = isProfileInactive ? RestoreIcon : EditIcon;

	return {
		key: 'dcr',
		label: isProfileInactive ? t('REQUEST ACTIVATION') : t('REQUEST CHANGE'),
		icon: <Icon fontSize={isCollapsed ? 'inherit' : undefined} />,
		onClick: () => ctx.openRequestChange(),
		variant: 'contained',
		iconOnly: isCollapsed
	};
};
